import type { File } from './file';
import type { Meeting } from './meeting';
import type { User } from './user';

export interface Quote {
  id: string;
  community_id: string;
  request_id: string;
  is_accepted: boolean;
  total: string;
  description: string;
  status_id: QuoteStatuses;
  status: QuoteStatus;
  rejection_reason: string;
  vendor_id: string | null;
  vendor?: any;
  created_by_id: string;
  created_by?: User;
  created_at: string;
  updated_at: string;
  files?: File[];
  payment_terms: string | null;
  payment_type: 'reserves' | 'operation' | 'other' | null;
  meeting_id: string | null;
  meeting?: Meeting;
}

export interface QuoteStatus {
  id: number;
  name: string;
  color: string;
  description: string | null;
}

export const Quote_Status = {
  1: 'Pending',
  2: 'Approved',
  3: 'Rejected',
  4: 'Expired',
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
  EXPIRED: 4,
} as const;
export type QuoteStatuses = keyof typeof Quote_Status;

export const QuotePaymentType = { OPERATIONS: 'operations', RESERVES: 'reserves', OTHER: 'other' } as const;
